import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import pages from "../../../constants/pages";
import { PrimaryLoadingButton } from "../../css components/Button";
import { signInMember } from "../../../redux/slices/memberSlice";
import SelectRole from "./Form";

const Card = styled(Box)`
  width: 100%;
  max-width: 400px;
  padding: 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 12px #376fd033;
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px #376fd055;
  }
`;

const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const Description = styled(Typography)`
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.5;
`;

const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  margin: 40px 0;
`;

export default function SegmentCards({
  role,
  authToken,
  userID,
  businessEntityID,
  currentBrand,
  userDashboardState,
  component = "",
  setCurrentBrand,
  brands,
  setUserDashboardState,
  loadingBrands,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState({
    new: false,
    existing: false,
  });
  async function handleNavigation(type) {
    setLoading((prev) => ({
      ...prev,
      [type]: true,
    }));

    if (component === "") {
      localStorage.setItem(
        "dashboardState" + currentBrand.ID,
        userDashboardState
      );
      sessionStorage.setItem("activeBrand", currentBrand.ID);
      sessionStorage.setItem("brandType", currentBrand.type);
      sessionStorage.setItem("role", "NORMAL_USER");
      sessionStorage.setItem("cohortType", type);
      await dispatch(
        signInMember({
          authToken,
          userID,
          businessEntityId: businessEntityID,
          brandType: currentBrand.type,
          cohortType: type,
        })
      );
    }

    setLoading((prev) => ({
      ...prev,
      [type]: false,
    }));
    if (type === "existing") {
      navigate(pages.audienceList.route);
    }

    if (type === "new") {
      navigate(pages.createAudience.route);
    }

    if (type === "publisher") {
      navigate(pages.campaignRequest.route);
    }
  }

  return (
    <Container>
      <Fragment>
        <Card>
          <Title>
            {userDashboardState === "monetization" &&
              "Choose brand to continue"}

            {userDashboardState === "promotion" && "Review Campaign Requests"}
          </Title>
          <Description>
            {userDashboardState === "monetization" &&
              "Select the brand you want to access and manage its audience and campaigns"}
            {userDashboardState === "promotion" &&
              "View all campaign requests submitted by brands and approve or reject them based on requirements."}
          </Description>

          <SelectRole
            component=""
            loadingBrands={loadingBrands}
            role={role}
            userDashboardState={userDashboardState}
            authToken={authToken}
            setUserDashboardState={setUserDashboardState}
            currentBrand={currentBrand}
            setCurrentBrand={setCurrentBrand}
            brands={brands}
            businessEntityID={businessEntityID}
            userID={userID}
          />
          <PrimaryLoadingButton
            sx={{ float: "inline-end" }}
            loading={loading.existing}
            onClick={() =>
              handleNavigation(
                userDashboardState === "monetization" ? "existing" : "publisher"
              )
            }
            variant="contained"
            disabled={!currentBrand.ID}
          >
            Continue
          </PrimaryLoadingButton>
        </Card>
      </Fragment>
    </Container>
  );
}
